import React, { useMemo, useEffect, useState, useRef, useContext, createContext } from "react";
import { Steps, Button, Progress, Tabs, message, Divider, Space, Table, Pagination, Result, Typography } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
const { Paragraph, Text } = Typography;
import { Uploader } from "../index";
import { lib, event } from "../index";
import "./import-data.less";

let context = createContext();

function Step1() {
    let { store, setStore, systemCode, code } = useContext(context);
    let [file, setFile] = useState(null);
    return (
        <div className="step1">
            <Divider orientation="left">步骤1：下载模板并完成数据录入</Divider>
            <div className="tips">
                请按照模板的格式准备导入的数据，模板中表头名称不可更，表头行不可删除，单次导入的数据不可超过10000条
            </div>
            <Space size={15} style={{ margin: "10px 0 30px" }}>
                <Button type="primary" onClick={() => window.open(store.src)}>
                    下载模板
                </Button>
                {store.failSrc && (
                    <Button type="danger" onClick={() => window.open(store.failSrc)}>
                        下载失败数据
                    </Button>
                )}
            </Space>
            <Divider orientation="left">步骤2：上传已经录入的数据文件</Divider>
            <div className="tips">文件后缀必须为xls或xlsx（即Excle格式），您可以点击上传文件或者拖拽文件至此处</div>
            <Uploader allowTypes={["xls", "xlsx"]} style={{ marginTop: "10px" }} onChange={file => setFile(file)} />
            <div style={{ marginTop: "15px" }}>
                <Button
                    type="primary"
                    onClick={() => {
                        if (!file) {
                            return message.error("请选上传Excel数据表");
                        }
                        // 导入参数的添加
                        let extend = {};
                        let importExtendParam = decodeURIComponent(window.location.search)
                            .slice(1)
                            .split("&")
                            .find(item => item.indexOf("importExtendParam") !== -1);
                        if (importExtendParam && importExtendParam.length > 0) {
                            let importExtendParamBase64 = window.atob(importExtendParam.split("=")[1]);
                            let ps = importExtendParamBase64.split("&");
                            ps.map(item => {
                                let [key, value] = item.split("=");
                                extend[key] = decodeURIComponent(value);
                            });
                        }
                        // decodeURIComponent(window.location.search).slice(1).split('&').map(item => {
                        //     let [key , value] = item.split('=');
                        //     if(['page_title' , 'api' , 'refresh_event'].indexOf(key) == -1){
                        //         extend[key] = value;
                        //     }
                        // });
                        lib.request({
                            url: "/park-gate/import/create",
                            data: {
                                systemCode,
                                code,
                                file,
                                extend,
                            },
                            needMask: true,
                            success: () => setStore({ ...store, status: 2, file }),
                        });
                    }}>
                    下一步
                </Button>
            </div>
        </div>
    );
}

function Step2() {
    let { store, setStore, systemCode, code } = useContext(context);

    function query() {
        lib.request({
            url: "/park-gate/import/query",
            data: {
                systemCode,
                code,
            },
            success: data => setStore({ ...store, ...data }),
        });
    }

    let { success, fail, unProcessed, total, percent = 0 } = store.progress || {};
    if (total) {
        percent = parseInt(((success + fail) * 100) / total);
    }
    useEffect(() => {
        query();
        let timer = setInterval(query, 3000);
        return () => {
            clearInterval(timer);
        };
    }, []);
    return (
        <div className="step2">
            <Progress percent={percent} showInfo={true} strokeWidth={16} status="active" />
            <div className="info" style={{ marginTop: "25px" }}>
                正在导入中<span className="link">{store.file?.name}</span>
            </div>
            <div className="info" style={{ marginTop: "3px" }}>
                共<span>{total}</span>条数据，已成功导入<span className="link">{success}</span>条，失败
                <span className="danger">{fail}</span>条，未完成<span>{unProcessed}</span>条
            </div>
        </div>
    );
}

function Step3() {
    let { store, setStore, systemCode, code } = useContext(context);
    let [groupData, setGroupData] = useState([]);
    let heightPanel = useRef();
    let [height, setHeight] = useState(300);

    function resize() {
        setHeight(heightPanel.current.offsetHeight);
    }

    function finish(retry) {
        lib.request({
            url: "/park-gate/import/confirm",
            data: {
                systemCode,
                code,
            },
            needMask: true,
            success: () => {
                let failSrc = retry ? store.failSrc : "";
                setStore({ ...store, status: 1, failSrc });
                lib.getParam("refresh_event") && event.emit(lib.getParam("refresh_event"));
            },
        });
    }

    useEffect(() => {
        lib.request({
            url: "/park-gate/import/getDataGroup",
            data: {
                systemCode,
                code,
            },
            success: data => {
                setGroupData(data);
            },
        });
        resize();
        event.on("window.resize", resize);
        return () => event.off("window.resize", resize);
    }, []);
    return (
        <div className="step3">
            <div style={{ marginLeft: "60px" }}>
                <div className="info">
                    共成功导入了<span className="">{store.progress?.total}</span>条信息，其中成功
                    <span className="link">{store.progress?.success}</span>条，
                    <span className="danger">{store.progress?.fail}</span>条出现异常导入失败。
                </div>
                <div className="tips" style={{ marginTop: "5px" }}>
                    请下载失败表，重新导入本次的失败项
                </div>
            </div>
            <div className="tabs">
                <Tabs
                    tabBarExtraContent={
                        <Space size={15}>
                            {store.failSrc && (
                                <Button type="danger" onClick={() => window.open(store.failSrc)}>
                                    失败数据
                                </Button>
                            )}
                            {store.successSrc && (
                                <Button type="primary" onClick={() => window.open(store.successSrc)}>
                                    成功数据
                                </Button>
                            )}
                        </Space>
                    }
                    items={[
                        {
                            label: "失败信息",
                            key: "1",
                            children: groupData.length > 0 && (
                                <SheetList groupData={groupData} height={height} needReason />
                            ),
                        },
                        {
                            label: "成功信息",
                            key: "2",
                            children: groupData.length > 0 && <SheetList groupData={groupData} height={height} />,
                        },
                    ]}
                />
                <div className="height-panel" ref={heightPanel}></div>
            </div>
            <div className="ft" style={{ marginTop: "15px" }}>
                <Space size={15}>
                    {store.progress?.fail > 0 && (
                        <Button type="danger" onClick={() => finish(true)}>
                            重新导入失败数据
                        </Button>
                    )}
                    <Button type="primary" onClick={() => finish()}>
                        完成
                    </Button>
                </Space>
            </div>
        </div>
    );
}
function StepFail() {
    let { store, setStore, systemCode, code } = useContext(context);

    let { success, fail, unProcessed, total, percent = 0 } = store.progress || {};
    if (total) {
        percent = parseInt(((success + fail) * 100) / total);
    }
    function finish(retry) {
        lib.request({
            url: "/park-gate/import/confirm",
            data: {
                systemCode,
                code,
            },
            needMask: true,
            success: () => {
                let failSrc = retry ? store.failSrc : "";
                setStore({ ...store, status: 1, failSrc });
            },
        });
    }
    return (
        <div className="step2">
            <Progress percent={percent} showInfo={true} strokeWidth={16} status="active" />
            <div className="info" style={{ marginTop: "25px" }}>
                正在导入中<span className="link">{store.file?.name}</span>
            </div>
            <div className="info" style={{ marginTop: "3px" }}>
                共<span>{total}</span>条数据，已成功导入<span className="link">{success}</span>条，失败
                <span className="danger">{fail}</span>条，未完成<span>{unProcessed}</span>条
            </div>
            <Result
                status={"error"}
                title={"导入失败"}
                subTitle={"请核对并修改以下信息后，再重新导入"}
                extra={[
                    <Button type={"primary"} key={"console"} onClick={() => finish(true)}>
                        重新上传
                    </Button>,
                ]}>
                <Paragraph>
                    <Text
                        strong
                        style={{
                            fontSize: 16,
                        }}>
                        失败原因可能如下:
                    </Text>
                </Paragraph>
                <Paragraph>
                    <CloseCircleOutlined className="error-icon" /> 导入列表名称错误
                </Paragraph>
                <Paragraph>
                    <CloseCircleOutlined className="error-icon" /> 系统升级环境异常
                </Paragraph>
                <Paragraph>
                    <CloseCircleOutlined className="error-icon" /> 数据格式错误
                </Paragraph>
            </Result>
        </div>
    );
}
function SheetList({ groupData = [], needReason = false, height = 500 }) {
    let [item, setItem] = useState(groupData[0]);
    let [sheetTitle, setSheetTitle] = useState([]);
    let [dataSource, setDataSource] = useState([]);
    let [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10, totalCount: 0 });
    let { systemCode, code } = useContext(context);

    let columns = [
        { title: "行号", dataIndex: "__index__", width: 80, fixed: "left" },
        ...sheetTitle.map(item => ({ title: item, dataIndex: item, width: 200 })),
    ];
    if (needReason) {
        columns.push({ title: "原因", width: 200, dataIndex: "__reason__", fixed: "right" });
    }
    useEffect(() => {
        getPageData();
    }, [item]);

    function getPageData() {
        lib.request({
            url: "/park-gate/import/pageData",
            data: {
                systemCode,
                code,
                groupName: item,
                success: !needReason,
                ...pagination,
            },
            success: data => {
                setSheetTitle(data.hdList);
                setDataSource(data.dataList);
                let page = data.page;
                setPagination({ currentPage: page.currentPage, pageSize: page.pageSize, totalCount: page.totalCount });
            },
        });
    }

    return (
        <>
            <Space size={15} split={<Divider type="vertical" />} className="sheet">
                {groupData &&
                    groupData.map(node => (
                        <div key={node} className={item === node ? "link" : ""} onClick={() => setItem(node)}>
                            {node}
                        </div>
                    ))}
            </Space>
            <div className="table-panel">
                <Table
                    size="small"
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    scroll={{ x: 80 + 200 * (sheetTitle.length + needReason), y: height - 60 }}
                    rowKey="__index__"></Table>
            </div>
            <div className={"pagination-panel"}>
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    pageSize={pagination.pageSize}
                    pageSizeOptions={["10", "20", "30", "40", "50", "100", "200"]}
                    current={pagination.currentPage}
                    total={pagination.totalCount}
                    onChange={(page, pageSize) => {
                        pagination.currentPage = page;
                        if (pagination.pageSize !== pageSize) {
                            pagination.pageSize = pageSize;
                            pagination.currentPage = 1;
                        }
                        setPagination({ ...pagination });
                        getPageData();
                    }}
                    showTotal={total => `总共 ${total} 条`}
                />
            </div>
        </>
    );
}

function ImportData({ url }) {
    let [store, setStore] = useState({
        status: 0,
        src: "",
        failSrc: "",
        successSrc: "",
        progress: {
            success: 0,
            fail: 0,
            total: 0,
            unProcessed: 0,
        },
    });
    let systemCode = lib.getParam("systemCode") ? lib.getParam("systemCode") : lib.config.systemCode,
        code = lib.getParam("code", url);
    useEffect(() => {
        lib.request({
            url: "/park-gate/import/query",
            data: {
                systemCode,
                code,
            },
            success: store => setStore(store),
        });
    }, []);
    const stepItems = useMemo(() => {
        let item = [{ title: "上传文件" }, { title: "导入中" }];
        if (store.status === 3) {
            item.push({ title: "导入成功", status: "finish" });
        } else if (store.status === -1) {
            item.push({ title: "导入失败", status: "error" });
        } else {
            item.push({ title: "导入成功" });
        }
        return item;
    }, [store.status]);

    const currentValue = useMemo(() => {
        if (store.status >= 0) {
            return store.status - 1;
        }
        return 2;
    }, [store.status]);

    return (
        <context.Provider value={{ store, setStore, systemCode, code }}>
            <div className="config-center-v3-import-data">
                <div style={{ margin: "20px 60px" }}>
                    <Steps current={currentValue} items={stepItems} />
                </div>
                <div style={{ padding: "0 30px" }}>
                    {store.status == -1 && <StepFail />}
                    {store.status == 1 && <Step1 />}
                    {store.status == 2 && <Step2 />}
                    {store.status == 3 && <Step3 />}
                </div>
            </div>
        </context.Provider>
    );
}

export default ImportData;
